import {
  arrayOf,
  customType,
  params,
  shape,
  string,
  bool,
  extend
} from '@thd-nucleus/data-sources';

const FilterInput = customType('FilterInput').shape({
  make: string(),
  valvesPerEngine: string(),
  driveType: string(),
  transmissionMfr: string(),
  bodyStyle: string(),
  brakes: string(),
  brakesABS: string(),
  cylinderHeadType: string(),
  bodyDoors: string(),
  engine: string(),
  fuelType: string(),
  trim: string(),
  wheelbase: string(),
  steering: string(),
  model: string(),
  ignitionSystemType: string(),
  bedStyle: string(),
  fuelDeliverySubType: string(),
  transmission: string(),
  powerOutput: string(),
  year: string(),
  aspiration: string(),
  springs: string()
});

const OptionType = customType('OptionType').enum(
  [
    'VALVESPERENGINE',
    'DRIVETYPE',
    'MAKE',
    'CYLINDERHEADTYPE',
    'FUELTYPE',
    'BODYDOORS',
    'STEERING',
    'WHEELBASE',
    'FUELDELIVERYSUBTYPE',
    'TRANSMISSION',
    'YEAR',
    'BEDSTYLE',
    'IGNITIONSYSTEMTYPE',
    'MODEL',
    'BODYSTYLE',
    'TRANSMISSIONMFR',
    'POWEROUTPUT',
    'SPRINGS',
    'ENGINE',
    'TRIM',
    'BRAKES',
    'BRAKESABS',
    'ASPIRATION'
  ]
);

export const fitmentItemsDataModel = {
  fitmentItems: params({
    fitmentType: customType('FitmentType').enum(['AUTOMOTIVE']).isRequired(),
    itemIds: arrayOf(string().isRequired()).isRequired(),
    filter: FilterInput
  }).arrayOf(shape({
    itemId: string(),
    partType: string(),
    fitType: string(),
    doesFit: string(),
    category: shape({
      id: string(),
      name: string()
    }),
    missingRequiredFields: arrayOf(shape({
      id: string(),
      value: string()
    })),
    hasAlternatives: bool(),
    alternativesUrl: string()
  }))
};

export const dataModel = extend({
  fitmentOptionsV1: params({
    fitmentType: customType('FitmentType').enum(['AUTOMOTIVE']).isRequired(),
    itemId: string(),
    optionType: OptionType,
    categoryId: string(),
    filter: FilterInput
  }).shape({
    options: arrayOf(shape({
      id: string(),
      option: string(),
      value: string()
    }))
  })
},
fitmentItemsDataModel
);